module.exports = __webpack_public_path__ + "img/top_b_other.0f29d8af.png";